import { render, staticRenderFns } from "./starDatePicker.vue?vue&type=template&id=23ef5c2b&"
import script from "./starDatePicker.vue?vue&type=script&lang=js&"
export * from "./starDatePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports